exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DistributionHistory-module__container--Vpmw4 {\r\n  background-color: #f8f8f8;\r\n  width: 100%;\r\n  display: flex;\r\n  box-sizing: border-box;\r\n  padding: 8px 16px;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "DistributionHistory-module__container--Vpmw4"
};